import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import type { LinkProps } from '@vlabs/uikit/components/controls/link/Link';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import { useGoToFaceDetailsTranslation } from './i18n';
import type { GoToFaceDetailsProps } from './types';

interface GoToFaceDetailsLinkProps extends GoToFaceDetailsProps, Omit<LinkProps, 'children' | 'icon' | 'to'> {}

function GoToFaceDetailsLink({
  faceId,
  ...props
}: GoToFaceDetailsLinkProps): React.JSX.Element {
  const { t } = useGoToFaceDetailsTranslation();

  return (
    <Link
      icon={<ArrowInCircleRightIcon />}
      size="medium"
      target="_blank"
      to={generatePath(routes.facePage, { faceId })}
      {...props}
    >
      {t('title')}
    </Link>
  );
}

export { GoToFaceDetailsLink };
